import { render, staticRenderFns } from "./HomeForm.vue?vue&type=template&id=d86f1d6c&scoped=true&"
import script from "./HomeForm.vue?vue&type=script&lang=js&"
export * from "./HomeForm.vue?vue&type=script&lang=js&"
import style0 from "./HomeForm.vue?vue&type=style&index=0&id=d86f1d6c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d86f1d6c",
  null
  
)

export default component.exports